import { render, staticRenderFns } from "./BuiltInMenuDemo.vue?vue&type=template&id=ee238ee8&scoped=true"
import script from "./BuiltInMenuDemo.vue?vue&type=script&lang=js"
export * from "./BuiltInMenuDemo.vue?vue&type=script&lang=js"
import style0 from "./BuiltInMenuDemo.vue?vue&type=style&index=0&id=ee238ee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee238ee8",
  null
  
)

export default component.exports